import { IProjectBuilder, IProjectBuilderOptions } from '../types';

import { createProjectBuilder } from '../generator/ProjectBuilder';

import esmodule from '../plugins/common/esmodule';
import containerClass from '../plugins/component/normalreact/containerClass';
import containerInitState from '../plugins/component/normalreact/containerInitState';
import containerInjectContext from '../plugins/component/normalreact/containerInjectContext';
import containerInjectUtils from '../plugins/component/normalreact/containerInjectUtils';
import containerInjectDataSourceEngine from '../plugins/component/normalreact/containerInjectDataSourceEngine';
import containerInjectI18n from '../plugins/component/normalreact/containerInjectI18n';
import containerLifeCycle from '../plugins/component/normalreact/containerLifeCycle';
import containerMethod from '../plugins/component/normalreact/containerMethod';
import jsx from '../plugins/component/normalreact/jsx';
import reactCommonDeps from '../plugins/component/normalreact/reactCommonDeps';
import css from '../plugins/component/style/css';
import constants from '../plugins/project/constants';
import i18n from '../plugins/project/i18n';
import utils from '../plugins/project/utils';

import normal from '../plugins/project/framework/normal';

import { prettier } from '../postprocessor';

export interface IceJsCcsProjectBuilderOptions extends IProjectBuilderOptions {}

export default function createNormalReactProjectBuilder(
  options?: IceJsCcsProjectBuilderOptions,
): IProjectBuilder {
  return createProjectBuilder({
    inStrictMode: options?.inStrictMode,
    extraContextData: { ...options },
    template: normal.template,
    plugins: {
      components: [
        reactCommonDeps(),
        esmodule({
          fileType: 'jsx',
        }),
        containerClass(),
        containerInjectContext(),
        containerInjectUtils(),
        containerInjectDataSourceEngine(),
        containerInjectI18n(),
        containerInitState(),
        containerLifeCycle(),
        containerMethod(),
        jsx({
          nodeTypeMapping: {
            Div: 'div',
            Component: 'div',
            Page: 'div',
            Block: 'div',
          },
        }),
        css(),
      ],
      pages: [
        reactCommonDeps(),
        esmodule({
          fileType: 'jsx',
        }),
        containerClass(),
        containerInjectContext(),
        containerInjectUtils(),
        containerInjectDataSourceEngine(),
        containerInjectI18n(),
        containerInitState(),
        containerLifeCycle(),
        containerMethod(),
        jsx({
          nodeTypeMapping: {
            Div: 'div',
            Component: 'div',
            Page: 'div',
            Block: 'div',
            // Box: 'div',
          },
        }),
        css(),
      ],
      router: [esmodule(), normal.plugins.router()],
      entry: [normal.plugins.entry()],
      constants: [constants()],
      utils: [esmodule(), utils('react')],
      i18n: [i18n()],
      menuData:[esmodule(),normal.plugins.menuData()],
      globalStyle: [normal.plugins.globalStyle('css')],
      htmlEntry: [normal.plugins.entryHtml()],
      packageJSON: [normal.plugins.packageJSON()],
    },
    postProcessors: [prettier()],
  });
}

export const plugins = {
  containerClass,
  containerInitState,
  containerInjectContext,
  containerInjectUtils,
  containerInjectI18n,
  containerInjectDataSourceEngine,
  containerLifeCycle,
  containerMethod,
  jsx,
  commonDeps: reactCommonDeps,

  /** @deprecated Please use commonDeps */
  reactCommonDeps,
};
